<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Dialysis EMR Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="dialysisType"
              disabled
              label="Dialysis Type"
            />
          </div>
    

          <div class="col-2">
            <ADSTextInput
              v-model="dialysisAccessMode"
              disabled
              label="Dialysis Access Mode"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="dialysisLocation"
              disabled
              label="Dialysis Location"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="otherDialysisLocation"
              disabled
              label="Other Dialysis Location"
            />
          </div>
   
          <div class="col-2">
            <ADSTextInput
              v-model="dialysisProvider"
              disabled
              label="Dialysis Provider"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="dialysisStartDate"
              disabled
              label="Dialysis Start Date"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "DialysisSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      dialysisType: this.getDialysisType( this.patientBundle ),
      dialysisAccessMode: this.getDialysisAccessMode( this.patientBundle ),
      dialysisLocation: this.getDialysisLocation( this.patientBundle ),
      otherDialysisLocation: this.getOtherDialysisLocation( this.patientBundle ),
      dialysisProvider: this.getDialysisProvider( this.patientBundle ),
      dialysisStartDate: this.getDialysisStartDate( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === observationCode && 
      _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
      if( !match[0] ) {
        return null;
      }
      const raw = _.get( match[0], `resource.component[0].${valuePath}` );
      if( raw === null || raw === undefined ) {
        return null;
      }
      return String( raw );
    },
    getDialysisType( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8059' );
    },
    getDialysisAccessMode( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8054' );
    },
    getDialysisLocation( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8055' );
    },
    getOtherDialysisLocation( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8057' );
    },
    getDialysisProvider( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8056' );
    },
    getDialysisStartDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8298', 'valueDateTime' );
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 330px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 330px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

</style>
